import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const PlaceHolderWrapper = styled.div`
  display: grid;
  height: 358px;
  grid-template-columns: 1fr;
  grid-template-rows: 200px auto;
  row-gap: 6px;

  .body {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 6px;
  }

  @media (${mediaQuery.tablet}) {
    height: 125px;
    grid-template-columns: 224px auto;
    grid-template-rows: auto;
    column-gap: 8px;
  }

  @media (${mediaQuery.mobile}) {
    height: 110px;
    grid-template-columns: 146px auto;
    grid-template-rows: auto;
  }
`;
